export default {
  'itemDetail.purchasedThisItem': 'purchased this item',
  'itemDetail.ProductDetailsPageSKUSelectionDrawer': 'Product details page_SKU selection drawer',
  'itemDetail.ProductDetailsPageSKUSelectionDrawerselectProducts':
    'Product details page_SKU selection drawer_select products',
  'itemDetail.ProductDetailsPageSKUSelectionDrawerOKButton':
    'Product details page_SKU selection drawer_OK button',
  'itemDetail.ProductDetailsPageSKUSelectionDrawerChooseSubscriptionMode':
    'Product details page_SKU selection drawer_Choose subscription mode',
  'itemDetail.FailedToCollectCouponPleaseTryAgainLater':
    'Failed to collect coupon, please try again later',
  'itemDetail.hasBeenRemoved': 'has been removed',
  'itemDetail.NoAppointmentsYet': 'No appointments yet',
  'itemDetail.AppointmentSuccessfulViewDetails': 'Appointment successful, view details',
  'itemDetail.willBe': 'will be',
  'itemDetail.OnSale': 'On sale',
  'itemDetail.AppointmentSuccessful': 'Appointment successful',
  'itemDetail.AppointmentFailed': 'Appointment failed',
  'itemDetail.bookNow': 'book now',
  'itemDetail.have': 'have',
  'itemDetail.TheAppointmentWasSuccessful': 'The appointment was successful',
  'itemDetail.AppointmentNotStarted': 'Appointment not started',
  'itemDetail.startAnAppointment': 'start an appointment',
  'itemDetail.hasNotStarted': 'has not started',
  'itemDetail.over': 'over',
  'itemDetail.robbed': 'robbed',
  'itemDetail.remaining': 'remaining',
  'itemDetail.ProductDetailsPagebuyButton': 'Product details page_buy button',
  'itemDetail.BuyNow': 'Buy now',
  'itemDetail.TheProductIsARestrictedProductYouCannotPurchaseItIfYouDoNotMeetTheRestrictedPurchaseConditions':
    'The product is a restricted product, you cannot purchase it if you do not meet the restricted purchase conditions',
  'itemDetail.snapUpNow': 'snap up now',
  'itemDetail.NotEligibleToGet': 'Not eligible to get',
  'itemDetail.NotEligibleForRedemption': 'Not eligible for redemption',
  'itemDetail.SoldOut': 'Sold out',
  'itemDetail.ChooseAnItem': 'Choose an item',
  'itemDetail.flashSale': 'flash sale',
  'itemDetail.GetItForFree': 'Get it for free',
  'itemDetail.RedeemNow': 'Redeem now',
  'itemDetail.individualShopping': 'individual shopping',
  'itemDetail.InitiateAGroupPurchase': 'Initiate a group purchase',
  'itemDetail.PurchaseInInstallments': 'Purchase in installments',
  'itemDetail.afterCoupon': 'after coupon',
  'itemDetail.Expect': 'Expect',
  'itemDetail.Minute': 'Minute',
  'itemDetail.day天hourminutesecond': '{day}天 {hour}:{minute}:{second}',
  'itemDetail.onlyLeftToEnd': 'only left to end',
  'itemDetail.MMMonthDDDayHHmm': 'MM month DD day HH:mm',
  'itemDetail.Finish': 'Finish',
  'itemDetail.immediateReduction': 'immediate reduction',
  'itemDetail.PleaseSelectAnItem': 'Please select an item',
  'itemDetail.InsufficientGrowthBeansGetItNow': 'Insufficient Growth Beans Get it now',
  'itemDetail.InsufficientBalanceOfGrowthBeans': 'Insufficient balance of growth beans',
  'itemDetail.CouponPurchase': 'Coupon purchase',
  'itemDetail.Sure': 'Sure',
  'itemDetail.ChooseHowToBuy': 'Choose how to buy',
  'itemDetail.YouHaveAlreadyActivatedThisProductYouCannotChooseToSubscribe':
    'You have already activated this product, you cannot choose to subscribe',
  'itemDetail.YouAreAlreadySubscribedToThisItem': 'You are already subscribed to this item',
  'itemDetail.ThisSubscriptionModelIsNotCurrentlySupported':
    'This subscription model is not currently supported',
  'itemDetail.oneTimePayment': 'one-time payment',
  'itemDetail.specialPrice': 'special price',
  'itemDetail.LimitedTimeOffer': 'Limited Time Offer',
  'itemDetail.ParameterError': 'Parameter error!',
  'itemDetail.share': 'share',
  'itemDetail.subscription': 'subscription',
  'itemDetail.accordingTo': 'according to',
  'itemDetail.delivery': 'delivery',
  'itemDetail.ExpressDelivery': 'Express delivery',
  'itemDetail.illustrate': 'illustrate',
  'itemDetail.callOfficial': 'call official',
  'itemDetail.ProductDetailsPageCustomerServiceButton':
    'Product Details Page_Customer Service Button',
  'itemDetail.customerService': 'customer service',
  'itemDetail.ActivitiesAndCouponsAreMutuallyExclusiveAndItIsMoreCostEffectiveToRecommendCoupons':
    'Activities and coupons are mutually exclusive, and it is more cost-effective to recommend coupons',
  'itemDetail.selected': 'selected',
  'itemDetail.HuabeiInstallmentoptional': 'Huabei installment (optional)',
  'itemDetail.perIssue': '/per issue',
  'itemDetail.PurchaseQuantity': 'Purchase quantity',
  'itemDetail.goToView': 'go to view',
  'itemDetail.YouHaveParticipatedInTheGroupGroupActivityClickTheButtonBelowToViewTheGroupGroupProgress':
    'You have participated in the group group activity, click the button below to view the group group progress',
  'itemDetail.ProductDetailsPageretainPopUpExposure': 'Product details page_retain pop-up exposure',
  'itemDetail.mall': 'mall',
  'itemDetail.ProductDetailsPageretainPopupContentButtonClick':
    'Product details page_retain popup content button click',
  'itemDetail.other': 'other',
  'itemDetail.ProductDetailsPageRetainTheButtonClickAtTheBottomOfThePopUpWindow':
    'Product Details Page_Retain the button click at the bottom of the pop-up window'
};
